import { OptionMenuModel } from './option-menu';

export class RoleModel {

    account_admin: boolean;
    sys_admin:boolean;

    code: string;
    description: string;
    status: string;
    created_timestamp: string;
    modified_timestamp: string;
    options_access: OptionMenuModel[];

    constructor(account_admin?: boolean) {
        this.account_admin = account_admin;// == undefined ? false: account_admin;
    }

}
